import WindsorApi from '../api/WindsorApi';
import { decorate, observable } from 'mobx';
import moment from 'moment';

class FamilyStore {
    private user: any;
    private windsorApi: WindsorApi;

    public families: any[] = null;

    constructor(user: any, windsorApi: WindsorApi) {
        this.user = user;
        this.windsorApi = windsorApi;
        this.loadFamilies();
    }

    loadFamilies() {
        this.windsorApi.getFamilies().then(families => {
            this.families = families.map(family => {
                return {
                    id: family.GUID,
                    name: family.Name,
                    description: family.Description,
                    workflowCount: family.WorkflowCount,
                    owner: family.Owner,
                    lastModified: moment(family.LastModified, 'YYYY-MM-DD HH:mm:ss.SSSSSS').valueOf(),
                    subscribed: family.Subscribers && family.Subscribers.includes(this.user.email)
                }
            });
        });
    }

    toggleSubscription(family: any) {
        const subscribe = !family.subscribed;
        if (this.families) {
            const familyToUpdate = this.families.find(({ id }) => id === family.id);
            if (familyToUpdate) {
                familyToUpdate.subscribed = subscribe;
            }
        }
        return this.windsorApi.updateFamilySubscription(subscribe, family.id);
    }
}

decorate(FamilyStore, {
    families: observable
});

export default FamilyStore;